module.exports = __webpack_public_path__ + "img/fish_snapper.a8948991.png";